'use client';

import { useState } from 'react';
import { FadeIn } from '@/components/common/FadeIn';

export function NewsletterSignup() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    // TODO: integrate with email service
    setSubmitted(true);
  }

  return (
    <section className="bg-primary-subtle">
      <div className="container mx-auto px-4 py-12 md:py-16">
        <FadeIn className="max-w-xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-text-primary">
            Sign Up for Our Newsletter
          </h2>
          <p className="text-text-secondary mt-2">
            to receive special offers and news
          </p>

          {submitted ? (
            <p className="mt-6 text-lg font-medium text-primary">
              Thank you for subscribing!
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="mt-6 flex flex-col sm:inline-flex sm:flex-row gap-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your email"
                className="w-full sm:w-80 rounded-lg border border-border-base bg-surface px-4 py-3 text-text-primary placeholder:text-text-tertiary focus:border-primary focus:ring-1 focus:ring-primary outline-none transition-colors"
              />
              <button
                type="submit"
                className="rounded-lg bg-primary text-onprimary font-medium py-3 px-6 hover:bg-primary-hover active:bg-primary-pressed transition-colors cursor-pointer whitespace-nowrap"
              >
                Subscribe
              </button>
            </form>
          )}
        </FadeIn>
      </div>
    </section>
  );
}
